import { Component, OnInit  } from '@angular/core';
import { OktaAuthService } from './services/auth.service';
import { NavigationEnd, Router } from '@angular/router';
import  { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'rxorders-support-ui';

  leftOpened = true;
  isLogout: boolean = false;
  toggle() {
    this.leftOpened = !this.leftOpened;
  }
  constructor(public oktaAuth: OktaAuthService,router: Router,private toastr:ToastrService){
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {        
        const urlParams = new URLSearchParams(event.url);
        const errorName = urlParams.get('error');
        const errorDescr = urlParams.get('error_description');

        if(errorName !== undefined && errorName !== "" && errorName !== null)
        {
          this.toastr.error(errorDescr + ' This page will be redirect to Okta Login Page in few seconds.'
          , errorName
          , {
            timeOut: 6000
          }).onHidden.subscribe(() => {
            //navigate to error message.
            this.toastr.clear();
            this.handleLogout();
            //router.navigate(['/logout']);
          });
        }
      }});

    router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        if(e.url == "/logout")
          this.isLogout = true;
        else
          this.isLogout = false;
      }
    });
  }
  async handleLogout() {
    localStorage.clear();
    await this.oktaAuth.logout();
  }

   ngOnInit(): void {
    const accessToken = this.oktaAuth.oktaAuth.tokenManager.getTokensSync().accessToken;
    
    this.oktaAuth.oktaAuth.tokenManager.on('expired', (_key, _token) => {
      this.toastr.warning(
        'Your session has expired. Redirecting to login.',
        'Session Timeout',
        { timeOut: 4000 }
      ).onHidden.subscribe(() => {
        this.oktaAuth.login('/home');
      });
    });
  }
}